import React, { useState } from "react";

const LABELS = ["Avant 3/4", "Face avant", "Face arrière", "Arrière 3/4", "Intérieur"];

export const VehicleGallery = ({ vehicle }) => {
  const images = vehicle.images?.length ? vehicle.images : [vehicle.image_url];
  const [idx, setIdx] = useState(0);
  return (
    <div data-testid="vehicle-gallery">
      <div className="rounded-3xl overflow-hidden border border-slate-200 bg-slate-100">
        <img src={images[idx]} alt={`${vehicle.brand} ${vehicle.model}`} className="w-full object-cover aspect-[3/2]" data-testid="gallery-main-image" />
      </div>
      {images.length > 1 && (
        <div className="mt-3 grid grid-cols-5 gap-2">
          {images.map((src, i) => (
            <button key={src} type="button" onClick={() => setIdx(i)} data-testid={`gallery-thumb-${i}`}
              className={`relative overflow-hidden rounded-xl border-2 transition-all ${i === idx ? "border-[#006233]" : "border-transparent opacity-70 hover:opacity-100"}`}>
              <img src={src} alt={LABELS[i] || ""} className="aspect-[3/2] w-full object-cover" />
              <span className="absolute bottom-0 inset-x-0 bg-black/50 text-[10px] text-white py-0.5 text-center">{LABELS[i] || `Photo ${i + 1}`}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
